module.exports = __webpack_public_path__ + "static/media/Whole-Home-Data-Backup.347de3e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-ASURION/Whole-Home-Data-Backup.jpg
// module id = 3772
// module chunks = 0